import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import { useUpdate } from '../context/update.provider';

export const UpdateModal = () => {
  const {
    isUpdateModalOpen,
    currentVersion,
    serverVersion,
    acceptUpdate,
    dismissUpdate,
  } = useUpdate();

  if (!isUpdateModalOpen) {
    return null;
  }

  return (
    <Dialog
      open={isUpdateModalOpen}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <SystemUpdateAltIcon sx={{ mr: 1, verticalAlign: 'middle' }} color="primary" />
        Update Available
      </DialogTitle>
      
      <DialogContent>
        <DialogContentText>
          A new version of AMS Admin is available with the latest features and improvements.
          If you have unsaved changes please click "Remind Me Later" then save the changes. You can then force the update by clicking the update icon in the bottom left.
        </DialogContentText>
        
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Current version: {currentVersion}
          {serverVersion && (
            <>
              <br />
              New version: {serverVersion}
            </>
          )}
        </Typography>
      </DialogContent>
      
      <DialogActions>
        <Button
          onClick={dismissUpdate}
          variant="contained"
          color="secondary"
        >
          Remind Me Later
        </Button>
        <div style={{ flex: "1 0 0" }} />
        <Button
          onClick={acceptUpdate}
          variant="contained"
          color="primary"
          startIcon={<SystemUpdateAltIcon />}
        >
          Update Now
        </Button>
      </DialogActions>
    </Dialog>
  );
};